module.exports = __webpack_public_path__ + "static/EnmTX_BosDeathTiger_L_A_cl-048a4456851c50849f90480ec52a041e.gif";